import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { BasicLayout } from "../../layouts/BasicLayout";
import NotificationsList from "../../components/Notifications/NotificationsList";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../notifications/firebase";

const NotificationListPage = () => {
  const [isShowNotifications, setShowNotifications] = useState(false);

  useEffect(() => {
    onMessage(messaging, () => {
      localStorage.setItem("isReload", false);
      localStorage.setItem("notifications", false);
      setShowNotifications(true);
    });
  }, []);
  return (
    <BasicLayout isShowNotifications={isShowNotifications}>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" fontWeight={500} fontSize={24}>
            Notifications
          </Typography>
        </Box>
      </Box>
      <NotificationsList isShowNotifications={isShowNotifications} />
    </BasicLayout>
  );
};

export default NotificationListPage;
